import React from 'react';

function FieldInput({ field, value, onChange, error }) {
  const commonProps = {
    id: field.name,
    name: field.name,
    value: value || '',
    onChange: (e) => onChange(field.name, e.target.value),
    style: error ? { borderColor: 'var(--red)' } : {}
  };

  return (
    <div className="form-group full">
      <label htmlFor={field.name}>
        {field.label} {field.required && <span className="required">*</span>}
      </label>

      {field.type === 'select' ? (
        <select {...commonProps}>
          <option value="">Select...</option>
          {field.options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
        </select>
      ) : field.type === 'textarea' ? (
        <textarea {...commonProps} rows={3} placeholder={field.placeholder}
          style={{ ...commonProps.style, resize: 'vertical', fontFamily: 'inherit', fontSize: 14, padding: '10px 13px', border: '1.5px solid var(--border)', borderRadius: 7 }}
        />
      ) : field.type === 'date' ? (
        <input type="date" {...commonProps} />
      ) : field.type === 'time' ? (
        <input type="time" {...commonProps} />
      ) : (
        <input type="text" placeholder={field.placeholder} {...commonProps} />
      )}

      {error
        ? <span className="hint" style={{ color: 'var(--red)' }}>{error}</span>
        : field.hint && <span className="hint">{field.hint}</span>
      }
    </div>
  );
}

const EmptyIcon = () => (
  <svg width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="8" y1="13" x2="12" y2="13" />
  </svg>
);

export default function EVSEForm({
  requiredFields, groups, selectedFields, formData, onChange, errors,
  title = 'Details', emptyHint = 'Tick a box on the left to add more details.'
}) {
  const totalSelected = selectedFields.length;

  return (
    <div className="evse-form-panel">
      <div className="evse-form-header">
        <h2>{title}</h2>
        <span className="evse-field-counter">
          {totalSelected} optional field{totalSelected !== 1 ? 's' : ''} selected
        </span>
      </div>

      <div className="evse-required-section">
        <div className="form-grid">
          {requiredFields.map(field => (
            <FieldInput
              key={field.name}
              field={{ ...field, required: true }}
              value={formData[field.name]}
              onChange={onChange}
              error={errors[field.name]}
            />
          ))}
        </div>
      </div>

      {totalSelected === 0 ? (
        <div className="evse-empty-hint">
          <EmptyIcon />
          <p>{emptyHint}</p>
        </div>
      ) : (
        groups.map(group => {
          const activeFieldsInGroup = group.fields.filter(f => selectedFields.includes(f.name));
          if (activeFieldsInGroup.length === 0) return null;

          return (
            <div className="dynamic-field-group" key={group.key}>
              <div className="dynamic-field-group-title">{group.title}</div>
              <div className="form-grid">
                {activeFieldsInGroup.map(field => (
                  <div className="dynamic-field-enter" key={field.name}>
                    <FieldInput
                      field={field}
                      value={formData[field.name]}
                      onChange={onChange}
                      error={errors[field.name]}
                    />
                  </div>
                ))}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}